import { render, staticRenderFns } from "./guardians-information.vue?vue&type=template&id=40753b08&"
import script from "./guardians-information.vue?vue&type=script&lang=js&"
export * from "./guardians-information.vue?vue&type=script&lang=js&"
import style0 from "./guardians-information.vue?vue&type=style&index=0&id=40753b08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports